import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=3494a7e5&scoped=true&"
import script from "./Sound.vue?vue&type=script&lang=js&"
export * from "./Sound.vue?vue&type=script&lang=js&"
import style0 from "./Sound.vue?vue&type=style&index=0&id=3494a7e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494a7e5",
  null
  
)

export default component.exports